/*eslint no-sequences: "off"*/
/*eslint no-empty-pattern: "off"*/

import { createSlice } from '@reduxjs/toolkit';
import { formatDate } from '@flexo/general';
import type { IFilesState } from './interfaces';
import { initState } from './init.state';
import { FetchFilesOncePerDayAsync } from './async.thunks';

export const FilesSlice = createSlice({
  name: 'files',
  initialState: initState,
  reducers: {
    SetFiles: (state: IFilesState, action: any) => {
      return {
        ...state,
        files: action?.payload || null,
        lastFetchedDay: formatDate(new Date()),
        error: null,
      };
    },
    ClearFiles: () => {
      return initState;
    },
  },
  extraReducers: (builder: any) => {
    builder.addCase(FetchFilesOncePerDayAsync.pending, (_state: IFilesState) => {
      const today = formatDate(new Date());
      return {
        ..._state,
        FetchFilesOncePerDayAsyncStatus: 'PENDING',
        lastAttemptDay: today,
        error: null,
      };
    });

    builder.addCase(FetchFilesOncePerDayAsync.rejected, (_state: IFilesState, action: any) => {
      return {
        ..._state,
        FetchFilesOncePerDayAsyncStatus: 'ERROR',
        error: action?.error?.message || 'Unexpected error',
      };
    });

    builder.addCase(FetchFilesOncePerDayAsync.fulfilled, (_state: IFilesState, action: any) => {
      const today = formatDate(new Date());
      const files = action?.payload?.files || null;

      return {
        ..._state,
        files,
        lastFetchedDay: files ? today : _state.lastFetchedDay,
        FetchFilesOncePerDayAsyncStatus: 'SUCCESS',
        error: null,
      };
    });
  },
});

export const { SetFiles, ClearFiles } = FilesSlice.actions;
export { FetchFilesOncePerDayAsync };

export const selectFiles = (state: any) => state?.files?.files || null;
export const selectHasFiles = (state: any) => Array.isArray(state?.files?.files) && state.files.files.length > 0;
export const selectFilesFetchStatus = (state: any) => state?.files?.FetchFilesOncePerDayAsyncStatus || 'IDLE';

export default FilesSlice.reducer;


